var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.5,18h-1.5V5.5c0-3.032-2.468-5.5-5.5-5.5h-7C2.468,0,0,2.468,0,5.5v14.5c0,2.206,1.794,4,4,4h13.5c1.93,0,3.5-1.57,3.5-3.5v-1c0-.828-.672-1.5-1.5-1.5Zm-4.5,0H6.5c-.828,0-1.5.672-1.5,1.5v.5c0,.552-.448,1-1,1s-1-.448-1-1V5.5c0-1.379,1.121-2.5,2.5-2.5h7c1.379,0,2.5,1.121,2.5,2.5v12.5Zm-3.939-12.789c.586.586.586,1.535,0,2.121l-1.892,1.892c-.517.517-1.195.775-1.875.775s-1.357-.258-1.874-.774l-.981-.981c-.585-.587-.585-1.536,0-2.122.586-.584,1.536-.585,2.122,0l.732.734,1.646-1.646c.586-.586,1.535-.586,2.121,0Zm0,6c.586.586.586,1.535,0,2.121l-1.892,1.892c-.517.517-1.195.775-1.875.775s-1.357-.258-1.874-.774l-.981-.981c-.585-.587-.585-1.536,0-2.122.586-.584,1.536-.585,2.122,0l.732.734,1.646-1.646c.586-.586,1.535-.586,2.121,0ZM24,2.114v11.495c0,1-.397,1.96-1.105,2.667l-.588.588c-.17.17-.445.17-.615,0l-.588-.588c-.707-.707-1.105-1.667-1.105-2.667V2C20,.827,21.009-.109,22.206.01c1.041.104,1.794,1.058,1.794,2.104Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/task-icon.968d9e4df511704e400740ac4088d108.svg";
export { ForwardRef as ReactComponent };